import React from 'react';
import PropTypes from 'prop-types';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMOReservationDialogHeaderView from './SMOReservationDialogHeaderView';

class SMOReservationCancelView extends React.Component {

  componentDidMount() {
    $(this.refs.form).find("input[type=radio]").on("change", (e)=>{
      $(".js-form-radio-select_message").hide();
      let $message = $(this.refs[e.currentTarget.id]);
      if ($message.length) {
        $message.fadeIn();
      }
    });
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  formDidSubmit(e){
    e.preventDefault();
    let selectedCheckBox = 0;
    for (let i = 0; i < this.refs.form.children[1].length; i++){
      if (this.refs.form.children[1][i].checked) {
        selectedCheckBox = this.refs.form.children[1][i].value;
        break;
      }
    }
    this.trackPageEvent('od cancel_reservation lost_reason_type_' + selectedCheckBox.toString());
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMOwnerResource.cancel(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.reservationDidCancel === 'function'){
          this.props.delegate.reservationDidCancel(data, xhr);
        }
      } else {
        if(this.props.delegate && typeof this.props.delegate.reservationDidFailToCancel === 'function'){
          this.props.delegate.reservationDidFailToCancel(error, xhr);
        }
      }
    });
  }

  render() {
    let reservation = this.props.reservation;
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <SMOReservationDialogHeaderView />
        <h2 className="dashboard-title mb30 ta-c"
          dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000026")}} />
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <div className="form-box">
            <h3 className="dashboard-title mb20">
              <span className="icon-form icon-form__required">{I18n.t("dashboard.label_000025")}</span>
              {I18n.t("dashboard.label_000138")}
              <span className="dashboard-title__supplement ml15">{I18n.t("dashboard.text_000029")}</span>
            </h3>
            <input type="radio" value="1" id="form-radio01__01" name="lost_reason_type" />
            <label htmlFor="form-radio01__01" className="form-radio__s">他の予約と重なってしまったため</label><br />
            <input type="radio" value="2" id="form-radio01__02" name="lost_reason_type" />
            <label htmlFor="form-radio01__02" className="form-radio__s">日程が変更になった・料金を変更したい</label><br />
            <div ref="form-radio01__02" className="js-form-radio-select_message dashboard-message__info mt10">
              <p><a target="_blank" href={Routes.edit_owner_dashboard_reservation_path(reservation.owner.username, reservation.uid)}>予約の編集</a> 画面から料金や日程を変更することができます。キャンセルをする前に対応が可能かご確認ください。</p>
            </div>
            <input type="radio" value="3" id="form-radio01__03" name="lost_reason_type" />
            <label htmlFor="form-radio01__03" className="form-radio__s">ご自身に関する特別な事情（重篤な病気、事故、自然災害等）</label><br />
            <input type="radio" value="4" id="form-radio01__04" name="lost_reason_type" />
            <label htmlFor="form-radio01__04" className="form-radio__s">ゲストにキャンセルを頼まれたため</label><br />
            <div ref="form-radio01__04" className="js-form-radio-select_message dashboard-message__info mt10">
              <p>承認後のキャンセルはホストとしての評価に影響があります。キャンセルの起因があなたでない場合は、<a target="_blank" href={Routes.owner_dashboard_message_path(reservation.owner.username, reservation.uid)}>{reservation.user.contact_name} さんにメッセージ</a> でキャンセルをしてもらうようお願いしましょう。</p>
            </div>
            <input type="radio" value="5" id="form-radio01__05" name="lost_reason_type" />
            <label htmlFor="form-radio01__05" className="form-radio__s">その他</label>
            <div ref="form-radio01__05" className="js-form-radio-select_message dashboard-message__info mt10">
              <textarea name="lost_reason_description" className="form-textarea h40 w400" placeholder="理由を記述してください"></textarea>
            </div>

            <h3 className="dashboard-title mb20 mt20">
              <span className="icon-form icon-form__optional">{I18n.t("dashboard.label_000060")}</span>
              {I18n.t("dashboard.label_000011")}
              <span className="dashboard-title__supplement ml15">
                ゲストにキャンセルが必要になった理由を下記に記述し、伝えて下さい（400字以内）
              </span>
            </h3>
            <textarea name="content" className="w500 h80" placeholder="理由を記述してください"></textarea>
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton
              title={I18n.t("dashboard.label_000108")}
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}
SMOReservationCancelView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMOReservationCancelView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationCancelView.jsx